export default function RambaLogo({ className = '' }: { className?: string }) {
  return (
    <img
      src="/ramba-logo.png"
      alt="Ramba"
      className={`object-contain ${className}`}
    />
  );
}
